import Vue from 'vue'
import Vuex from 'vuex'
import login from '../modules/login'
import usuarios from '../modules/usuarios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: false, // Indica si existe un proceso de carga 
    //Snackbar
    snackbar: false,
    mensaje: '',
    tipo: ''
    //FIN Snackbar
  },
  mutations: {
    SET_LOADING(state, valor){
      state.loading = valor;
    },
    SET_SNACKBAR(state, valores){
      state.snackbar = valores.snackbar;
      if(valores.tipo !== null){
        state.tipo = valores.tipo;
      }
      if(valores.mensaje !== null){
        state.mensaje = valores.mensaje;
      }
    }
  },
  actions: {
    setLoading({commit}, valor){
      commit('SET_LOADING', valor);
    },
    setSnackbar({commit}, valores){
      commit('SET_SNACKBAR', valores);
    }
  },
  modules: {
    login,
    usuarios,
  }
})
